import React from "react";
import CountUp from "react-countup";
import "./Stats.css";

const statsData = [
  { id: 1, value: 10, suffix: "+", label: "Years Experience" },
  { id: 2, value: 200, suffix: "+", label: "Projects Completed" },
  { id: 3, value: 3, suffix: "M+", label: "Sq Ft Area Developed" },
  { id: 4, value: 10000, suffix: "+ MT", label: "Steel Work Done" },
];

const Stats = () => {
  return (
    <section className="stats-section">
      <div className="stats-container">
        {statsData.map((stat) => (
          <div key={stat.id} className="stat-box">
            <h2 className="stat-number">
              <CountUp end={stat.value} duration={3} separator="" />
              {stat.suffix}
            </h2>
            <p className="stat-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
